<template>
  <div class="d-flex flex-column w-full black--text">
    <p class="section-title mb-0">{{ $t("components.bookingForm.field.pickup") }}</p>
    <span class="booking-details-span">{{ details.origin.address }}</span>

    <div v-for="(waypoint, index) in details.waypoints" :key="index">
      <p class="booking-details-p mt-3 mb-0">{{ $t("components.bookingForm.field.waypoint") }}</p>
      <span class="booking-details-span">{{ waypoint.address }}</span>
    </div>

    <p class="booking-details-p mt-3 mb-0">{{ $t("components.bookingForm.field.dropoff") }}</p>
    <span class="booking-details-span">{{ details.destination.address }}</span>

    <p v-if="details.pickupTime" class="booking-details-p mt-3 mb-0">
      {{ $t("components.bookingForm.section.date") }}:
    </p>
    <span v-if="details.pickupTime" class="booking-details-span">{{ formattedDate(details.pickupTime) }}</span>

    <!-- Flight Details Start -->
    <p class="booking-details-p mt-3 mb-0" v-if="details.bookingProperties && details.bookingProperties.flightInfo">{{ $t("components.bookingForm.field.flightDetails") }}</p>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo && details.bookingProperties.flightInfo.type === 'pickup'"><span v-if="details.bookingProperties.flightInfo.airline">{{ details.bookingProperties.flightInfo.airline }} - </span> {{ details.bookingProperties.flightInfo.number || 'N/A' }}</span>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo && details.bookingProperties.flightInfo.type === 'pickup'">
      <span v-if="details.bookingProperties.flightInfo.type === 'pickup'">{{ $t("components.bookingForm.field.flightArrivalTime") }}</span>
      {{ flightTimeLocal }}
    </span>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo">{{ $t("components.bookingForm.field.terminal") }} {{ details.bookingProperties.flightInfo.terminal  || 'N/A' }}</span>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo">{{ $t("components.bookingForm.field.totalPassengers") }} {{ details.bookingProperties.flightInfo.totalPassengers }}</span>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo">{{ $t("components.bookingForm.field.smallBags") }} {{ details.bookingProperties.flightInfo.totalSmallBags }}</span>
    <span class="booking-details-span" v-if="details.bookingProperties && details.bookingProperties.flightInfo">{{ $t("components.bookingForm.field.largeBags") }} {{ details.bookingProperties.flightInfo.totalLargeBags }}</span>
    <!-- Flight Details end -->

    <!-- Passenger Name -->
    <p class="booking-details-p mt-3 mb-0">{{ $t("components.bookingForm.field.passenger") }}</p>
    <span class="booking-details-span">
      {{ details.userInfo.givenName }} {{ details.userInfo.familyName || "" }}
    </span>

    <!-- Phone -->
    <p class="booking-details-p mt-3 mb-0">{{ $t("components.bookingForm.field.phone") }}</p>
    <span class="booking-details-span">{{ details.userInfo.phone }}</span>

    <!-- Attribute Extras -->
    <template v-if="hasSelectedAttributeExtras">
      <p class="booking-details-p mt-3 mb-0">
        {{ $t('entity.booking.attributeExtras.selectedExtras') }}
      </p>
      <span class="booking-details-span">
        {{ formattedAttributeExtras }}
      </span>
    </template>

  </div>
</template>

<script>
import moment from "moment";
import { time } from "@/helpers/dateTime";
import { mapGetters } from 'vuex';
const { BookingUiTransformer } = require('../../mixins/BookingUiTransformer');

export default {
  name: "BookingDetails",
  props: {
    /** @type {BookingApiDto} */
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formattedDate(date) {
      return moment(date).format("LLL");
    },
  },
  computed: {
    ...mapGetters({
      currencySymbol: "bookingChannel/currencySymbol",
    }),

    flightTimeLocal() {
      if (!this.details.bookingProperties.flightInfo.arrivalTimeLocal) {
        return '';
      }
      return time(this.details.bookingProperties.flightInfo.arrivalTimeLocal);
    },

    /**
     * @return {Boolean}
     */
    hasSelectedAttributeExtras() {
      return (this.details
        && Array.isArray(this.details.attributeExtras)
        && (this.details.attributeExtras.length > 0));
    },

    /**
     * @return {string|null}
     */
    formattedAttributeExtras() {
      if (this.hasSelectedAttributeExtras) {
        return BookingUiTransformer.formatSelectedAttributeExtrasForInlineDisplay({
         currencySymbol: this.currencySymbol,
          selectedAttributeExtras: this.details.attributeExtras,
        });
      }
      return null;
    }
  }
};
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0;
}
</style>

<style lang="scss" scoped>
.booking-details-span {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #333333;
}

.booking-details-p {
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 19px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 8px;
}
</style>
